import { render, staticRenderFns } from "./BlockEcwidStore.vue?vue&type=template&id=506ee8a1&scoped=true&"
import script from "./BlockEcwidStore.vue?vue&type=script&lang=js&"
export * from "./BlockEcwidStore.vue?vue&type=script&lang=js&"
import style0 from "./BlockEcwidStore.vue?vue&type=style&index=0&id=506ee8a1&lang=scss&scoped=true&"
import style1 from "./BlockEcwidStore.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ee8a1",
  null
  
)

export default component.exports